import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../form/Button";
import { useTranslation } from "react-i18next";
import Modal from "../elements/Modal";
import aiImage from "../../assets/images/ai.svg";
import pencilImage from "../../assets/images/pencil.svg";
import Image from "../elements/Image";

const EventAddModal = ({ triggerButtonLabel = "", triggerBtnIcon }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useSelector((state) => state?.langProvider);
  const [open, setOpen] = useState({ isOpen: false });

  return (
    <>
      <Button
        buttonIcon={triggerBtnIcon}
        buttonLabel={t(triggerButtonLabel)}
        buttonLabelClasses={"uppercase"}
        buttonFunction={() => {
          setOpen({ isOpen: true });
        }}
      />
      <Modal
        isOpen={open.isOpen}
        setIsOpen={() => {
          setOpen({ isOpen: false });
        }}
        title={t("How do you want to build your event?")}
        size="xl4"
      >
        <div className="grid grid-cols-12 gap-4">
          <button
            type="button"
            className="col-span-12 md:col-span-6 p-5 bg-slate-100 rounded-lg border border-transparent hover:border-deep-purple transition-all duration-300 cursor-pointer flex flex-col items-center"
            onClick={() => {
              navigate(`/${lang}/user/events/event-manage`);
              setOpen({ isOpen: false });
            }}
          >
            <Image src={pencilImage} alt={"ai"} classes={"w-8 h-8"} />
            <div className="text-lg text-center font-semibold pt-3">
              {t("Start from scratch")}
            </div>
            <div className="text-center text-surface-05 font-medium text-sm">
              {t("Add all your event details, create new tickets")}
            </div>
          </button>
          <button
            type="button"
            className="col-span-12 md:col-span-6 p-5 bg-slate-100 rounded-lg border border-transparent hover:border-deep-purple transition-all duration-300 cursor-pointer flex flex-col items-center"
            onClick={() => {
              navigate(`/${lang}/user/events/event-manage-ai`);
              setOpen({ isOpen: false });
            }}
          >
            <Image src={aiImage} alt={"ai"} classes={"w-8 h-8"} />
            <div className="text-lg text-center font-semibold pt-3">
              {t("Create event faster with AI")}
            </div>
            <div className="text-center text-surface-05 font-medium text-sm">
              {t(
                "Answer a few quick questions to generate an event that's ready to publish almost instantly"
              )}
            </div>
          </button>
        </div>
      </Modal>
    </>
  );
};

export default EventAddModal;
